'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var _PublishNewHomesForm2 = _interopRequireDefault(_PublishNewHomesForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CommodityInput = function (_PureComponent) {_inherits(CommodityInput, _PureComponent);function CommodityInput() {var _temp, _this, _ret;_classCallCheck(this, CommodityInput);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.
    state = {
      value: '' }, _this.


    handleAddCommodity = function () {var
      value = _this.state.value;var _this$props =
      _this.props,canAddCommodity = _this$props.canAddCommodity,onClick = _this$props.onClick;

      if (canAddCommodity && value && onClick) {
        onClick(value);
        _this.setState({ value: '' });
      }
    }, _this.

    handleChange = function (event) {return _this.setState({ value: event.target.value });}, _temp), _possibleConstructorReturn(_this, _ret);}CommodityInput.prototype.

  render = function render() {var _cx;var _props =
    this.props,translate = _props.translate,canAddCommodity = _props.canAddCommodity,hasError = _props.hasError,meta = _props.meta;
    return (
      _react2.default.createElement('div', { className: _PublishNewHomesForm2.default.inputWrapper },
        _react2.default.createElement('input', {
          type: 'text',
          placeholder: translate('addNewProject', 'commoditiesPlaceholder'),
          dir: 'auto',
          value: this.state.value,
          onChange: this.handleChange,
          className: (0, _classnames2.default)(_PublishNewHomesForm2.default.extrasInput, (_cx = {}, _cx[
          _PublishNewHomesForm2.default.hasError] = hasError && meta.touched, _cx)),

          'aria-invalid': hasError }),

        canAddCommodity &&
        _react2.default.createElement('button', {
            type: 'button',
            className: _PublishNewHomesForm2.default.addObject,
            onClick: this.handleAddCommodity },

          _react2.default.createElement('span', { className: _PublishNewHomesForm2.default.plus }, '+'))));




  };return CommodityInput;}(_react.PureComponent);exports.default =


CommodityInput;

CommodityInput.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  canAddCommodity: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func.isRequired,
  hasError: _propTypes2.default.bool,
  meta: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/CommodityInput.js
// module id = 3029
// module chunks = 0